/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_African_Languages23Inputs */

const en__field__enum_additionalstudyinterests_study_african_languages23 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_African_Languages23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`African Languages, Media and Communication`)
};

const de__field__enum_additionalstudyinterests_study_african_languages23 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_African_Languages23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afrikanische Sprachen, Medien und Kommunikation`)
};

/**
* | output |
* | --- |
* | "African Languages, Media and Communication" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_African_Languages23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_african_languages23 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_African_Languages23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_African_Languages23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_african_languages23(inputs)
	return de__field__enum_additionalstudyinterests_study_african_languages23(inputs)
});
export { _field__enum_additionalstudyinterests_study_african_languages23 as "_field__enum_additionalStudyInterests_STUDY_AFRICAN_LANGUAGES" }